module.exports = __webpack_public_path__ + "img/step3.b2c041e8.png";